import { NOTIFICATIONS_CATEGORIES } from 'entities/Notification/consts/notificationCategories';
import { NOTIFICATIONS_TYPES } from 'entities/Notification/consts/notificationTypes';
import {
	REPORT_CONVERSION_TYPES,
	REPORT_CONVERSION_TYPES_OPTIONS,
	REPORT_STATUS_OPTIONS,
	REPORT_STATUSES,
} from 'entities/Report';
import { TRANSACTION_REASONS, TRANSACTION_TYPES } from 'entities/Transaction';
import { MENU_ITEMS } from 'features/Navigation/consts/menuItems';
import {
	BROKEN_LINKS_ERRORS,
	CATEGORIES,
	COUNTRIES,
	CURRENCIES,
	ERRORS,
	FULL_LANGUAGES,
	LANGUAGES,
	MONTHS,
	MONTHS_OPTIONS,
	POSTBACK_PARAMS,
	POSTBACK_STATUSES,
	PURCHASE_TYPES,
	RELATION_STATUSES,
	REPORT_TYPES,
	SOURCE_STATUSES,
	SOURCE_TYPES,
	STATS_UPDATES,
	VALIDATION_MESSAGES,
} from 'shared/consts';

export const dynamicTrans = () => ({
	categories: CATEGORIES(),
	countries: COUNTRIES(),
	languages: LANGUAGES(),
	relationStatuses: RELATION_STATUSES(),
	sourceStatuses: SOURCE_STATUSES(),
	menuItems: MENU_ITEMS(),
	notificationCategories: NOTIFICATIONS_CATEGORIES(),
	notificationTypes: NOTIFICATIONS_TYPES(),
	validationMessages: VALIDATION_MESSAGES(),
	transactionReasons: TRANSACTION_REASONS(),
	transactionTypes: TRANSACTION_TYPES(),
	reportStatuses: REPORT_STATUSES(),
	reportStatusOptions: REPORT_STATUS_OPTIONS(),
	reportConvertions: REPORT_CONVERSION_TYPES(),
	reportConvertionsOptions: REPORT_CONVERSION_TYPES_OPTIONS(),
	fullLanguages: FULL_LANGUAGES(),
	months: MONTHS(),
	monthsOptions: MONTHS_OPTIONS(),
	currencies: CURRENCIES(),
	errors: ERRORS(),
	statUpdates: STATS_UPDATES(),
	reportTypes: REPORT_TYPES(),
	postbackStatuses: POSTBACK_STATUSES(),
	postbackParams: POSTBACK_PARAMS(),
	brokenLinksErrors: BROKEN_LINKS_ERRORS(),
	sourceTypes: SOURCE_TYPES(),
	purchaseTypes: PURCHASE_TYPES(),
});
